import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useBuilderChatUrl } from './hooks';
import { BuilderChatPopup } from '../../components/BuilderChatPopup';
import { getBuilderChatOpened } from '../../selectors/builderChat';
import { closeBuilderChat } from '../../slices/builderChat';

export const BuilderChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();

  const isChatOpened = useSelector(getBuilderChatOpened);
  const chatUrl = useBuilderChatUrl({ isChatOpened });

  const handleClose = React.useCallback(() => dispatch(closeBuilderChat()), [dispatch]);

  if (!isChatOpened) {
    return null;
  }

  return <BuilderChatPopup url={chatUrl} onClose={handleClose} />;
};
